import { eulerToQuaternion as Z, quaternionToEuler as v } from "../math/utils.js";
import { formatSyntaxError as m, formatValueCountError as E, formatTypeMismatch as d, getComponentProperties as x, formatPropertyError as z, formatEnumError as q } from "./diagnostics.js";
function P(e) {
  return e.replace(/-([a-z])/g, (o, i) => i.toUpperCase());
}
function I(e) {
  if (e = e.trim(), e.startsWith("0x"))
    return parseInt(e, 16);
  if (e.startsWith("#"))
    return parseInt(e.slice(1), 16);
  if (e === "true") return 1;
  if (e === "false") return 0;
  const o = parseFloat(e);
  return isNaN(o) ? e : o;
}
function y(e) {
  return e.trim().split(/\s+/).map(I);
}
function O(e, o) {
  const i = `${o}X`, c = `${o}Y`, f = `${o}Z`;
  return i in e && c in e && f in e;
}
function S(e, o) {
  const i = `${o}X`, c = `${o}Y`, f = `${o}Z`, h = `${o}W`;
  return i in e && c in e && f in e && h in e;
}
function C(e, o, i, c) {
  const f = c.config.getEnums(e);
  if (f && f[o]) {
    const h = f[o], r = i.toLowerCase();
    if (r in h)
      return h[r];
    const p = Object.keys(h), a = q(
      e,
      o,
      i,
      p
    );
    throw new Error(a);
  }
  return null;
}
function B(e, o, i, c, f, h) {
  const r = {}, p = o.split(";").map((a) => a.trim()).filter((a) => a.length > 0);
  for (const a of p) {
    const $ = a.indexOf(":");
    if ($ === -1) {
      const t = m(
        e,
        a,
        '"property: value"',
        "missing colon after property name"
      );
      throw new Error(t);
    }
    const s = a.slice(0, $).trim(), w = a.slice($ + 1).trim(), Y = c.config.getAdapter(e, s);
    if (Y) {
      h !== void 0 && Y(h, w, c);
      continue;
    }
    if (c.config.shouldSkip(e, s))
      continue;
    if (!s || !w) {
      const t = m(
        e,
        a,
        '"property: value"',
        s ? "value is empty" : "property name is empty"
      );
      throw new Error(t);
    }
    const u = P(s);
    if ((u === "euler" || u === "rotation") && "eulerX" in i) {
      const t = y(w);
      if (t.length === 1) {
        const l = Number(t[0]) || 0;
        r.eulerX = l, r.eulerY = l, r.eulerZ = l;
      } else if (t.length === 3)
        r.eulerX = Number(t[0]) || 0, r.eulerY = Number(t[1]) || 0, r.eulerZ = Number(t[2]) || 0;
      else {
        const l = E(
          e,
          s,
          "1 (broadcast) or 3 (x, y, z degrees)",
          t.length
        );
        throw new Error(l);
      }
      const n = Z(
        r.eulerX || 0,
        r.eulerY || 0,
        r.eulerZ || 0
      );
      r.rotX = n.x, r.rotY = n.y, r.rotZ = n.z, r.rotW = n.w;
      continue;
    }
    if (u === "rot" && S(i, "rot")) {
      console.warn(
        `[${e}.rot] Direct quaternion values are deprecated. Use 'euler' or 'rotation' for Euler angles in degrees instead.`
      );
      const t = y(w);
      if (t.length === 3) {
        const n = Z(
          Number(t[0]) || 0,
          Number(t[1]) || 0,
          Number(t[2]) || 0
        );
        r.rotX = n.x, r.rotY = n.y, r.rotZ = n.z, r.rotW = n.w, r.eulerX = Number(t[0]) || 0, r.eulerY = Number(t[1]) || 0, r.eulerZ = Number(t[2]) || 0;
      } else if (t.length === 4) {
        r.rotX = Number(t[0]) || 0, r.rotY = Number(t[1]) || 0, r.rotZ = Number(t[2]) || 0, r.rotW = Number(t[3]) || 1;
        const n = v(
          r.rotX,
          r.rotY,
          r.rotZ,
          r.rotW
        );
        r.eulerX = n.x, r.eulerY = n.y, r.eulerZ = n.z;
      } else {
        const n = E(
          e,
          s,
          "3 (Euler angles) or 4 (quaternion)",
          t.length
        );
        throw new Error(n);
      }
      continue;
    }
    if (O(i, u)) {
      const t = y(w);
      if (t.length === 1) {
        const n = Number(t[0]) || 0;
        r[`${u}X`] = n, r[`${u}Y`] = n, r[`${u}Z`] = n;
      } else if (t.length === 3)
        r[`${u}X`] = Number(t[0]) || 0, r[`${u}Y`] = Number(t[1]) || 0, r[`${u}Z`] = Number(t[2]) || 0;
      else {
        const n = E(
          e,
          s,
          "1 (broadcast) or 3 (x, y, z)",
          t.length
        );
        throw new Error(n);
      }
      continue;
    }
    if (u in i) {
      const t = y(w);
      if (t.length !== 1) {
        const l = E(
          e,
          s,
          "1",
          t.length
        );
        throw new Error(l);
      }
      const n = t[0];
      if (typeof n == "string") {
        const l = C(e, u, n, c);
        if (l !== null)
          r[u] = l;
        else if (f) {
          const g = f.getEntityByName(n);
          if (g !== null)
            r[u] = g;
          else {
            const X = d(
              e,
              s,
              "number or entity name",
              `string "${n}"`
            );
            throw new Error(X);
          }
        } else {
          const g = d(
            e,
            s,
            "number",
            `string "${n}"`
          );
          throw new Error(g);
        }
      } else
        r[u] = n;
      continue;
    }
    const b = P(s);
    if (b in i) {
      const t = y(w);
      if (t.length !== 1) {
        const l = E(
          e,
          s,
          "1",
          t.length
        );
        throw new Error(l);
      }
      const n = t[0];
      if (typeof n == "string") {
        const l = C(
          e,
          b,
          n,
          c
        );
        if (l !== null)
          r[b] = l;
        else if (f) {
          const g = f.getEntityByName(n);
          if (g !== null)
            r[b] = g;
          else {
            const X = d(
              e,
              s,
              "number or entity name",
              `string "${n}"`
            );
            throw new Error(X);
          }
        } else {
          const g = d(
            e,
            s,
            "number",
            `string "${n}"`
          );
          throw new Error(g);
        }
      } else
        r[b] = n;
      continue;
    }
    const V = x(i), W = z(
      e,
      s,
      "Property not found",
      V
    );
    throw new Error(W);
  }
  return r;
}
export {
  B as parseComponentProperties
};
//# sourceMappingURL=property-parser.js.map
